/**
 * 🟥 P26.33 · Guard único para los fences de acción de DamyxIA.
 *
 * Bug: los parsers de bloques markdown usaban ```` ```(\w+)? ```` y con
 * ```` ```damyxia-action ```` capturaban language="damyxia" y código
 * "-action\n{...}". Ese JSON terminaba en la Vista Previa React y Babel
 * fallaba con "Missing semicolon", mostrando además restos de trabajos
 * viejos de la conversación.
 */

export const DAMYX_FENCE_LANG = 'damyxia-action';

/** El bloque es un payload de acción de DamyxIA (JSON), no código. */
export const isDamyxActionPayload = (code) => {
  if (typeof code !== 'string') return false;
  const s = code.trim();
  if (s.startsWith('-action')) return true;
  if (s.includes('damyxia-action')) return true;
  if (!s.startsWith('{')) return false;
  return /"(action|type)"\s*:\s*"(create|update|project|module|document|note|task)"/.test(s);
};

/** El bloque debe ignorarse por completo (no es código del usuario). */
export const isDamyxActionBlock = (language, code) =>
  String(language || '').toLowerCase().startsWith('damyxia') || isDamyxActionPayload(code);
